import React from "react";
import Popover from "@material-ui/core/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import Box from "@material-ui/core/Box";
import { HelpOutlineMaterialIcon } from "Icons/MaterialIcons";
import "./PopOverComponent.scss";

const PopOverComponent = ({ label: textLabel, children }) => {
	return (
		<PopupState variant="popover" popupId="demo-popup-popover">
			{(popupState) => (
				<>
					<label className="addOrEditForm__label" {...bindTrigger(popupState)}>
						<span className="label">{textLabel}</span>
						<HelpOutlineMaterialIcon className="infoIcon" />
						<span></span>
					</label>
					<Popover
						{...bindPopover(popupState)}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "center",
						}}
						transformOrigin={{
							vertical: "top",
							horizontal: "center",
						}}
					>
						<Box p={2}>{children}</Box>
					</Popover>
				</>
			)}
		</PopupState>
	);
};

export default PopOverComponent;
